<template>
  <div class="guest-checkout-password">
    <slot />

    <Form
      v-if="selectedOption === 'INVOICE' && !success"
      id="guest-password-form"
      :action="innerAction"
      :method="method"
      @submit="onSubmit"
    >
      <csrf-input
        ref="csrf"
      />
      <div class="form__group">
        <input-vee4
          name="password"
          type="password"
          :rules="{required: selectedOption === 'INVOICE' && guest, regex: 'passwordRegex', min: 'passwordMin', max: 'passwordMax'}"
          :label="$t('global.password.label')"
          :button="{
            type: 'button',
            icon: 'eye'
          }"
        />
      </div>

      <div class="form__group">
        <input-vee4
          name="passwordRepeat"
          type="password"
          rules="required|confirmed:@password"
          :label="$t('global.password_repeat.label')"
          :button="{
            type: 'button',
            icon: 'eye'
          }"
        />
      </div>

      <div class="form__group">
        <button
          type="submit"
          name="guest-checkout"
          class="guest-checkout | button button--alt button--icon button--icon_next"
          v-html="$t('global.checkout.login.submit')"
        />
      </div>
      <div
        id="general-checkout-pw-error"
        class="input__error | input-error"
      >
        {{ $t('checkout.payment_type.INVOICE.error') }}
      </div>
    </Form>

    <div
      v-else-if="selectedOption === 'INVOICE'"
      class="guest-checkout-password_success"
    >
      {{ $t('checkout.payment_type.INVOICE.success') }}
    </div>
  </div>
</template>

<script>
import FormMixin from '../../utilities/vueMixins/formMixin/formMixin'
import CsrfInput from '../csrfInput/csrfInput'
import pigeon from '../../utilities/js/pigeon/pigeon'
import {Form} from 'vee-validate'
import InputVee4 from '../inputVue/inputVee4.vue'

export default {
  components: {
    InputVee4,
    Form,
    CsrfInput
  },
  mixins: [
    FormMixin,
  ],
  props: {
    guest: {
      type: Boolean,
      default: false,
    },
    selectedOption: String,
  },
  data() {
    return {
      success: false,
      innerAction: '/register/transform/',
    }
  },
  mounted() {
    pigeon.subscribe('checkGuestCheckoutPassword', this.checkGuestCheckoutPassword.bind(this))
  },
  methods: {
    onSubmit(values, actions) {
      this.submitAjaxFormVee4(values, (errors) => {
        errors.forEach(fieldError => {
          actions.setFieldError(fieldError.field, fieldError.msg)
        })
      }, () => {
        this.success = true
      })
    },
    checkGuestCheckoutPassword() {
      const errorElement = document.querySelector('#general-checkout-pw-error')
      if (!document.querySelector('#guest-password-form')) {
        if (errorElement) {
          errorElement.style.display = 'none'
        }
        document.paymentbaseform.submit()
      } else {
        window.scrollToElement('#general-checkout-pw-error')
        if (errorElement) {
          errorElement.style.display = 'block'
        }
        return false
      }
    }
  }
}

</script>
